import CarAutocaravanOutline from '@adv-mt/mt-svg-icons/lib/CarAutocaravanOutline.js'
import CarBuggieOutline from '@adv-mt/mt-svg-icons/lib/CarBuggieOutline.js'
import CarCheckOutline from '@adv-mt/mt-svg-icons/lib/CarCheckOutline.js'
import CarClassicOutline from '@adv-mt/mt-svg-icons/lib/CarClassicOutline.js'
import CarIndustrialOutline from '@adv-mt/mt-svg-icons/lib/CarIndustrialOutline.js'
import CarMiniOutline from '@adv-mt/mt-svg-icons/lib/CarMiniOutline.js'
import CarSportOutline from '@adv-mt/mt-svg-icons/lib/CarSportOutline.js'
import CarVanOutline from '@adv-mt/mt-svg-icons/lib/CarVanOutline.js'
import MotorcycleClassicOutline from '@adv-mt/mt-svg-icons/lib/MotorcycleClassicOutline.js'
import MotorcycleMiniOutline from '@adv-mt/mt-svg-icons/lib/MotorcycleMiniOutline.js'
import MotorcycleOutline from '@adv-mt/mt-svg-icons/lib/MotorcycleOutline.js'
import MotorcycleQuadOutline from '@adv-mt/mt-svg-icons/lib/MotorcycleQuadOutline.js'

export const ICONS_MAPPING = {
  car: 'car',
  carAutocaravan: 'carAutocaravan',
  carBuggie: 'carBuggie',
  carIndustrial: 'carIndustrial',
  carMini: 'carMini',
  carSport: 'carSport',
  motoClassic: 'motoClassic',
  minimotos: 'minimotos',
  quads: 'quads'
}

export const ICONS_MAP = {
  car: CarCheckOutline,
  carAutocaravan: CarAutocaravanOutline,
  carBuggie: CarBuggieOutline,
  carClassic: CarClassicOutline,
  carIndustrial: CarIndustrialOutline,
  carMini: CarMiniOutline,
  carSport: CarSportOutline,
  carVan: CarVanOutline,
  moto: MotorcycleOutline,
  motoClassic: MotorcycleClassicOutline,
  motoMini: MotorcycleMiniOutline,
  quad: MotorcycleQuadOutline
}
